import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

// API
import { useApi } from 'Service/axios';

// components
import { FormBox } from './style';

import { useParams, Link, useNavigate } from 'react-router-dom';

const EditarAlmoxarifado = ({ ...others }) => {
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const { id } = useParams();
    const navigate = useNavigate();
    const api = useApi();
    const [submitError, setSubmitError] = useState(null);
    const [almoxarifado, setAlmoxarifado] = useState(null);

    const getalmoxarifado = async (id) => {
        const response = await api.getAlmoxarifadoById(id);
        setAlmoxarifado(response.data.almoxarifado);
    };

    function isAnyFieldEmpty(values) {
        const fieldsToCheck = ['descricao'];

        for (const field of fieldsToCheck) {
            if (values[field].trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleRegister = async (values) => {
        // monta um objeto apenas com valores !== de ""
        const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
            if (value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {});

        // monta o payload final
        const almoxarifado = filteredValues;
        try {
            const response = await api.updateAlmoxarifado(id, almoxarifado);
            navigate('/main/almoxarifado');
        } catch (error) {
            setSubmitError(error);
        }
    };

    useEffect(() => {
        getalmoxarifado(id);
    }, []);

    return (
        <>
            {almoxarifado !== null && (
                <Formik
                    initialValues={{
                        descricao: almoxarifado?.descricao,
                        submit: null
                    }}
                    validationSchema={Yup.object().shape({
                        descricao: Yup.string().required('Descrição é obrigatório')
                    })}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                        try {
                            if (scriptedRef.current) {
                                setStatus({ success: true });
                                setSubmitting(false);
                            }
                            handleRegister(values);
                        } catch (err) {
                            if (scriptedRef.current) {
                                setStatus({ success: false });
                                setErrors({ submit: err.msg });
                                setSubmitting(false);
                            }
                        }
                    }}
                >
                    {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                        <form noValidate onSubmit={handleSubmit} {...others} style={{ display: 'flex', flexDirection: 'column' }}>
                            <FormBox>
                                <FormControl
                                    fullWidth
                                    error={Boolean(touched.descricao && errors.descricao)}
                                    sx={{ ...theme.typography.customInput }}
                                >
                                    <InputLabel htmlFor="outlined-adornment-descricao-register">Descrição</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-descricao-register"
                                        type="text"
                                        value={values.descricao}
                                        name="descricao"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        inputProps={{}}
                                    />
                                    {touched.descricao && errors.descricao && (
                                        <FormHelperText error id="standard-weight-helper-text--register">
                                            {errors.descricao}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </FormBox>

                            {!submitError && errors.submit ? (
                                <Box sx={{ mt: 3 }}>
                                    <FormHelperText error>{errors.submit}</FormHelperText>
                                </Box>
                            ) : (
                                <Box sx={{ mt: 3 }}>
                                    <FormHelperText error>{submitError}</FormHelperText>
                                </Box>
                            )}

                            {/* BOTÕES */}
                            <Box sx={{ mt: 2, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                <Link to={'/main/almoxarifado'}>
                                    <Button>Voltar</Button>
                                </Link>
                                <AnimateButton>
                                    <Button
                                        disableElevation
                                        disabled={isSubmitting || isAnyFieldEmpty(values)}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                    >
                                        {isSubmitting || isAnyFieldEmpty(values)
                                            ? 'Descrição do almoxarifado está faltando'
                                            : 'Atualizar Almoxarifado'}
                                    </Button>
                                </AnimateButton>
                            </Box>
                        </form>
                    )}
                </Formik>
            )}
        </>
    );
};

export default EditarAlmoxarifado;
